import script from "./AgendaTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AgendaTable.vue?vue&type=script&setup=true&lang=js"

import "./AgendaTable.vue?vue&type=style&index=0&id=54f854cc&lang=scss&scoped=true"
import "./AgendaTable.vue?vue&type=style&index=1&id=54f854cc&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54f854cc"]])

export default __exports__